import React, { useState, useEffect } from 'react'
import {
  Edit,
  required,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useTranslate,
  NumberInput,
  SelectInput,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { clientServices } from 'src/services/reservation/client/client.service'

export const NumberingEdit = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const [clients, setClients] = useState([])
  const [loadingClients, setLoadingClients] = useState(false)

  useEffect(() => {
    getClient()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getClient = async () => {
    try {
      setLoadingClients(true)
      const allClients = await clientServices.getByAll()
      if (allClients) {
        setClients(allClients.map((client) => ({ ...client, client_id: client.id })))
        return
      }
      notify(`clients not found`, { type: 'error' })
    } catch (error) {
      notify(`clients not found`, { type: 'error' })
    } finally {
      setLoadingClients(false)
    }
  }

  const onSuccess = () => {
    notify('ra.notification.updated_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.numbering') },
    })
    redirect('/numbering')
  }

  const onError = () => {
    notify('ra.notification.updated_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.numbering') },
    })
  }

  return (
    <Edit {...props} mutationMode='pessimistic' mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.update_numbering')}>
        <SimpleForm
          toolbar={
            <CardCrudBottomButtons
              btnSave={true}
              btnDelete={true}
              fieldsName={['short_name']}
              genderElement='femenine'
            />
          }
        >
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.prefix')} required>
              <TextInput source='prefix' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.client')} required>
              {loadingClients ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='client_id'
                  optionText='long_name'
                  label=''
                  fullWidth
                  choices={clients}
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_branch_number')}>
              <NumberInput label='' source='document_branch_number' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.last_used')}>
              <NumberInput
                label=''
                source='last_used'
                fullWidth
                validate={[required()]}
                defaultValue={0}
              />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
